export default "__VITE_ASSET__y_E9IMEV__"